module.exports = __webpack_public_path__ + "img/featured-tweet-left-line-flush.0b24092e.svg";